import { observer } from 'mobx-react';
import * as React from 'react';
import FreebusyStore from '../../FreebusyStore';
import CoachingReadyView from './CoachingReadyView';

interface Props {
  freebusyStore: FreebusyStore;
}

class CoachingReadyButton extends React.Component<Props, {}> {
  componentDidMount() {
    this.props.freebusyStore.loading();
  }

  render() {
    // FreeBusy opens its own picker from the button id.
    return <CoachingReadyView buttonId="freebusy-pickatime-button" onClick={() => {}} />;
  }
}

export default observer(CoachingReadyButton);
